var lib_core = require("lib-core");
var PackageGeneratorInspectorConfig = require("../packageGeneratorInspectorConfig.js");
var IpcPthPadGeneratorInteractionModel = require('./ipcPthPadGeneratorInteractionModel.js');

var CrystalHC49PadGeneratorInteractionModel = function(IpcPthPadGeneratorData, userSettingsModel, showFootprintParams) {
    IpcPthPadGeneratorInteractionModel.apply(this, arguments);
};

lib_core.inherit(CrystalHC49PadGeneratorInteractionModel, IpcPthPadGeneratorInteractionModel);
CrystalHC49PadGeneratorInteractionModel.$class = 'CrystalHC49PadGeneratorInteractionModel';

module.exports = CrystalHC49PadGeneratorInteractionModel;

CrystalHC49PadGeneratorInteractionModel.prototype.getInspectorElementForTerminalWidth = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('b', this.LCLZ('leadDiameter', 'Lead Diameter'), true, null, false, this.terminalWidth, this.userSettingsModel.distanceUnit)];
};

CrystalHC49PadGeneratorInteractionModel.prototype.getInspectorElementForBodyLength = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('D', this.LCLZ('bodyLength', 'Body Length'), false, this.bodyWidthMin, false, this.bodyWidthMax, this.userSettingsModel.distanceUnit)];
};

CrystalHC49PadGeneratorInteractionModel.prototype.getInspectorElementForBodyWidth = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('E', this.LCLZ('bodyWidth', 'Body Width'), false, this.bodyLengthMin, false, this.bodyLengthMax, this.userSettingsModel.distanceUnit)];
};

CrystalHC49PadGeneratorInteractionModel.prototype.getInspectorElements = function() {
    var imElements = [];

    imElements = imElements.concat(this.getInspectorElementForPadShape());
    imElements = imElements.concat(this.getInspectorElementForDensityLevel());
    imElements = imElements.concat(this.getInspectorElementForPitch());
    imElements = imElements.concat(this.getInspectorElementForTerminalWidth());
    imElements = imElements.concat(this.getInspectorElementForBodyLength());
    imElements = imElements.concat(this.getInspectorElementForBodyWidth());
    imElements = imElements.concat(this.getInspectorElementForBodyHeight());
    imElements = imElements.concat(this.getInspectorElementForMapping());
    imElements = imElements.concat(this.getInspectorElementForPadHoleRatio());

    this.inspectorElements.input_elements = imElements;
    return this.inspectorElements;
};
